import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setIsEmbedded } from "@/redux/actions/embeddedAction";
import helpers from "@/utils/helpers";
import {
  ORIGIN_CAMPAIGN_SOAT,
  ORIGIN_CONTENT_SOAT,
  SOAT_PATH,
} from "@/utils/constants/campaign";
import { URL_EMBEDDED_SOAT } from "@/consts/embbed";

const useEmbeddedNavigation = () => {
  const dispatch = useDispatch();
  const { origenCampania, origenContenido } = helpers.getCampaign();
  const [originEmbedded, setOriginEmbedded] = useState(false);
  const urlEmbedded = localStorage.getItem(URL_EMBEDDED_SOAT);

  useEffect(() => {
    if (
      origenCampania === ORIGIN_CAMPAIGN_SOAT &&
      origenContenido === ORIGIN_CONTENT_SOAT &&
      urlEmbedded
    ) {
      setOriginEmbedded(true);
      dispatch(setIsEmbedded(true));
    }
  }, []);

  const handleClickBack = () => {
    const { origin } = window.location;
    const url = `${origin}/${SOAT_PATH}${urlEmbedded}`;
    window.location.href = url;
  };

  return { originEmbedded, handleClickBack, urlEmbedded };
};

export default useEmbeddedNavigation;
